export default __webpack_public_path__ + "static/media/colored-arrow-left.604ad63a.svg";